import { render, staticRenderFns } from "./VncScreenshot.vue?vue&type=template&id=c3db3c92"
import script from "./VncScreenshot.vue?vue&type=script&lang=js"
export * from "./VncScreenshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports